
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class KaratRateGrid extends Serenity.EntityGrid<KaratRateRow, any> {
        protected getColumnsKey() { return 'OMS.KaratRate'; }
        protected getDialogType() { return KaratRateDialog; }
        protected getIdProperty() { return KaratRateRow.idProperty; }
        protected getInsertPermission() { return KaratRateRow.insertPermission; }
        protected getLocalTextPrefix() { return KaratRateRow.localTextPrefix; }
        protected getService() { return KaratRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}